var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("detail", {
            ref: "detail",
            on: { detail: _vm.setDetail, applay: _vm.showApply },
          }),
          _c(
            "div",
            {
              staticClass: "footer",
              class: [_vm.isCollapsed ? "footer-collapsed" : ""],
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.detail.status,
                      expression: "detail.status",
                    },
                  ],
                  staticClass: "footer-btn",
                },
                [
                  _vm.buttonNavigation.previous || _vm.buttonNavigation.next
                    ? [
                        _c(
                          "el-button",
                          {
                            attrs: { disabled: !_vm.buttonNavigation.previous },
                            on: {
                              click: function ($event) {
                                return _vm.checkId("previous")
                              },
                            },
                          },
                          [_vm._v("上一条")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { disabled: !_vm.buttonNavigation.next },
                            on: {
                              click: function ($event) {
                                return _vm.checkId("next")
                              },
                            },
                          },
                          [_vm._v("下一条")]
                        ),
                      ]
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "info", plain: "" },
                      on: {
                        click: function ($event) {
                          return _vm.returnToApprovals()
                        },
                      },
                    },
                    [_vm._v("返回")]
                  ),
                  !_vm.$root.desktopWorkbench &&
                  _vm.detail.businessName &&
                  _vm.detail.businessName !== "noticeDetail"
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", plain: "" },
                          on: {
                            click: function ($event) {
                              return _vm.lookAccount()
                            },
                          },
                        },
                        [_vm._v("查看账号")]
                      )
                    : _vm._e(),
                  !_vm.$root.desktopWorkbench &&
                  _vm.detail.businessName === "noticeDetail"
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", plain: "" },
                          on: {
                            click: function ($event) {
                              return _vm.lookAnnouncement()
                            },
                          },
                        },
                        [_vm._v("查看")]
                      )
                    : _vm._e(),
                  _vm.detail.canApprove
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            type: "change",
                            loading: _vm.btnChangeLoading,
                          },
                          on: { click: _vm.onChange },
                        },
                        [_vm._v("转交")]
                      )
                    : _vm._e(),
                  _vm.detail.canAddApprover
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            loading: _vm.btnAddUserLoading,
                          },
                          on: { click: _vm.onAddUser },
                        },
                        [_vm._v("添加审批人")]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        loading: _vm.btnCommentLoading,
                      },
                      on: { click: _vm.onComment },
                    },
                    [_vm._v("评论")]
                  ),
                  _vm.detail.canApprove
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            loading: _vm.btnApplyLoading,
                          },
                          on: { click: _vm.onApply },
                        },
                        [_vm._v("审批")]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.btnExport },
                      on: {
                        click: function ($event) {
                          return _vm.getPdf("export")
                        },
                      },
                    },
                    [_vm._v("导出")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.btnPrint },
                      on: {
                        click: function ($event) {
                          return _vm.getPdf("print")
                        },
                      },
                    },
                    [_vm._v("打印")]
                  ),
                ],
                2
              ),
            ]
          ),
        ],
        1
      ),
      _c("popComment", { ref: "popComment", on: { ok: _vm.setComment } }),
      _c("popApply", { ref: "popApply", on: { ok: _vm.setApply } }),
      _c("org-picker", {
        ref: "orgPicker",
        attrs: { title: _vm.pickerTitle },
        on: { ok: _vm.selected },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }